import React, { useEffect, useState } from 'react';

import { fetchCostCenterReport, fetchCostCenterReportView } from 'actions/costCenter';
import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import useUserAccount from 'hooks/useUserAccount';
import { CostCenter } from 'models/costCenter';
import { CostCenterReportRequest, CostCenterReportResponse } from 'models/costCenterReport';
import CostCenterReport from 'screens/components/CostCenterReport';
import { getCostCenters } from 'services/costCenterService';

const CostCenterReportContainer = () => {
  const [costCenterList, setCostCenterList] = useState<CostCenter[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  const { t } = useStoreTranslation();
  const [report, setReport] = useState<CostCenterReportResponse>();
  const userAccount = useUserAccount();

  const handleFetchCostCenterReport = async (filters: CostCenterReportRequest, type: string) => {
    if (type === 'email') {
      handleDownloadReport(filters);
    }

    if (type === 'screen') {
      handleReportOnScreen(filters);
    }
  };

  const handleReportOnScreen = async (filters: CostCenterReportRequest) => {
    setIsSubmitting(true);
    try {
      const {
        data: { data },
      } = await fetchCostCenterReportView(filters);

      setReport(data);

      setIsSubmitting(false);
    } catch (e) {
      setIsSubmitting(false);
      throw e;
    }
  };

  const handleDownloadReport = async (filters: CostCenterReportRequest) => {
    setIsSubmitting(true);
    try {
      fetchCostCenterReport(filters);

      toast.add({ type: 'success', message: t('costCenter.report.filterForm.success') });
      setIsSubmitting(false);
    } catch (e) {
      setIsSubmitting(false);
      throw e;
    }
  };

  useEffect(() => {
    const getData = async () => {
      try {
        setIsLoading(true);
        const res = await getCostCenters(userAccount.companyId);

        res.data.result.unshift({
          id: '00000000-0000-0000-0000-000000000000',
          code: '',
          name: t('costCenter.report.filterForm.products.all'),
        } as CostCenter);
        setCostCenterList(res.data.result);

        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);

        toast.add({
          type: 'danger',
          message: t('costCenter.report.filterForm.error'),
        });
      }
    };

    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CostCenterReport
      costCenterList={costCenterList}
      fetchReportSummary={handleFetchCostCenterReport}
      isLoading={isLoading}
      isSubmit={isSubmitting}
      report={report}
    />
  );
};

export default CostCenterReportContainer;
